import * as React from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button, Input, InputGroup, InputGroupAddon } from "reactstrap";
import ReactTable from "react-table";
import { Column } from "react-table";
import "react-table/react-table.css";
import i18n from "../i18n";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAsync } from "utils/net";

export interface SearchInScenarioProps {
    isOpen: boolean;
    onClose: () => void;
    onSearchItemSelected: (text: string) => void;
    //   onSearchResultFound: (searchResultItems: any) => void;
}
export interface SearchInScenarioState {
    searchResultItems: any;
    textToSearchValue: string;
    disableSearchButton: boolean;
    searchResults: any,
    loading: boolean
}

export default class SearchInScenario extends React.Component<
    SearchInScenarioProps,
    SearchInScenarioState
    > {
    constructor(props: SearchInScenarioProps) {
        super(props);
        this.state = {
            textToSearchValue: "",
            searchResultItems: null,
            disableSearchButton: true,
            searchResults: [],
            loading: false
        };

    }

    //   async componentDidUpdate(prevProps: SearchInScenarioProps) {
    //     if (
    //       this.props.isOpen &&
    //       (prevProps.textToSearch !== this.props.textToSearch || !prevProps.isOpen)
    //     ) {
    //       const reply = await getAsync(
    //           "https://jsonplaceholder.typicode.com/posts/1"
    //         // `/api/designer/getscenarioshistory?scenarioName=${
    //         //   this.props.textToSearch
    //         // }`
    //       );
    //       const searchResults = await reply.json();
    //       this.setState({
    //         searchResultItems: searchResults
    //       });
    //     }
    //   }

    private filterMethod = (filter: any, row: any) =>
        new RegExp(filter.value, "i").test(String(row[filter.id]));

    private async searchData() {
        this.setState({
            loading: true
        });
        const request = await getAsync(
            `/api/designer/searchText?textToSearch=${
            this.state.textToSearchValue
            }`
        );
        const searchResults = await request.json();
        this.setState({
            searchResults,
            loading: false
        });
    }

    private handleChange(event: any) {
        if (event.target.value) {
            var textToSearch = event.target.value as string;
            if (textToSearch.length >= 3) {
                this.setState({
                    disableSearchButton: false
                });
            } else {
                this.setState({
                    disableSearchButton: true
                });

            }
        }
        this.setState({
            textToSearchValue: event.target.value
        });
    }

    private columns: Column[] = [
        {
            Header: i18n.Scenarios.Search.Scenario,
            id: "scenarioName",
            accessor: (value: any) => value.scenarioModel.partitionKey
        },
        {
            Header: i18n.Scenarios.Search.Occurrences,
            id: "occurrences",
            accessor: (value: any) => value.occurrences
        },
        {
            Header: i18n.Scenarios.Search.OpenScenario,
            filterable: false,
            maxWidth: 50,
            Cell: row => (
                <Button
                    size="sm"
                    color="primary"
                    onClick={() => this.props.onSearchItemSelected(row.original.scenarioModel)}
                >
                    <FontAwesomeIcon icon={faEye} />
                </Button>
            )
        }
    ];

    private onClosed() {
        // this.setState(
        //     {
        //         searchResults: [],
        //         textToSearchValue: ""
        //     }
        // );
    }

    private async onOpened() {
        if (this.state.textToSearchValue && this.state.textToSearchValue.length >= 3) {
            await this.searchData();
        }
    }

    render() {
        const { isOpen } = this.props;

        return (
            <Modal isOpen={isOpen} size="lg" onClosed={() => this.onClosed()} onOpened={() => this.onOpened()}>
                <ModalHeader>{i18n.Scenarios.Search.Title}</ModalHeader>
                <ModalBody>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">??</InputGroupAddon>
                        <Input
                            value={this.state.textToSearchValue}
                            placeholder="Type the text to search"
                            onChange={e => this.handleChange(e)}
                        />
                        <Button
                            color="primary"
                            onClick={() => this.searchData()}
                            disabled={this.state.disableSearchButton}
                        >
                            Search
                        </Button>
                    </InputGroup>
                    {isOpen && (

                        <ReactTable
                            loading={this.state.loading}
                            data={this.state.searchResults}
                            columns={this.columns}
                            defaultFilterMethod={this.filterMethod}
                            defaultPageSize={10}
                            defaultSorted={[
                                {
                                    id: "timestamp",
                                    desc: true
                                }
                            ]}
                            className="-striped -highlight"
                        />
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="primar" onClick={() => this.props.onClose()}>
                        {i18n.Global.Close}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/designer/show-search.tsx